export enum MailboxNewMessageAction {
  REPLY = 'reply',
  REPLY_ALL = 'reply_all',
  FORWARD = 'forward',
  COMPOSE = 'compose',
  EDIT = 'edit',
}
